import { Spin } from 'antd';
import { CustomModal } from 'components/molecules/PricingSimulator/Modals/ScenarioColumnEditModal';
import { useState, useEffect } from 'react';
import { antIcon } from 'components/molecules/Filter/FilterApplyButton';
import SelectionDropDown from 'components/molecules/SelectionDropDown';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onExport: (selectedValue: any) => void;
    list: any[];
    loading?: boolean;
    defaultSelected?: any;
};

const ExportPlanModal = ({ open, onCancel, onExport, list, loading = false, defaultSelected }: PopupProps) => {
    const [selectedValue, setSelectedValue] = useState<any>(
        defaultSelected || (list && list.length > 0 ? list[0].value : null),
    );

    useEffect(() => {
        if (open && list && list.length > 0) {
            setSelectedValue(defaultSelected || list[0].value);
        }
    }, [open, list, defaultSelected]);

    const handleExport = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        if (loading) return;
        const selectedItem = list.find((item) => item.value === selectedValue);
        onExport(selectedItem);
        onCancel(e);
    };

    return (
        <CustomModal
            width={480}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={onCancel}
            onOk={handleExport}
            title="Export"
            centered
            open={open}
            okButtonProps={{ style: { borderRadius: 6 } }}
            okText={loading ? <Spin indicator={antIcon} style={{ color: 'white' }} /> : 'Export'}
        >
            <div className="border border-backgroundGreyAlt6 rounded p-3">
                <p className="px-3 font-xs text-fontGreyAlt mb-3">Select plan to export</p>
                <div className="px-3">
                    <SelectionDropDown
                        list={list}
                        selectedList={selectedValue}
                        setSelectedList={setSelectedValue}
                        checkedListObject={selectedValue}
                        disabled={loading}
                        searchable={true}
                        sortByStartsWith={true}
                        selectAll={false}
                        radioMode={true}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default ExportPlanModal;
